import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  class: "gst-svg-icon",
  d: "M3.938 18.938h2.624a.187.187 0 0 0 .188-.188v-1.5A.75.75 0 0 0 6 16.5H4.5a.75.75 0 0 0-.75.75v1.5a.187.187 0 0 0 .188.188ZM9 12.75a.75.75 0 0 0-.75.75v5.25a.187.187 0 0 0 .188.188h2.624a.187.187 0 0 0 .188-.188V13.5a.75.75 0 0 0-.75-.75H9ZM13.5 14.25a.75.75 0 0 0-.75.75v3.75a.187.187 0 0 0 .188.188h2.624a.187.187 0 0 0 .188-.188V15a.75.75 0 0 0-.75-.75h-1.5ZM18 9a.75.75 0 0 0-.75.75v9a.187.187 0 0 0 .188.188h2.625a.187.187 0 0 0 .187-.188v-9A.75.75 0 0 0 19.5 9H18ZM18.75 3a1.5 1.5 0 0 0-1.46 1.845.19.19 0 0 1-.04.166l-2.444 2.85a.19.19 0 0 1-.188.06 1.5 1.5 0 0 0-1.43.398.186.186 0 0 1-.193.044l-1.633-.543a.188.188 0 0 1-.127-.15 1.5 1.5 0 1 0-2.944.553.187.187 0 0 1-.063.188l-2.175 1.815a.191.191 0 0 1-.196.027 1.5 1.5 0 1 0 .853 1.025.188.188 0 0 1 .062-.188l2.175-1.815a.187.187 0 0 1 .196-.027 1.5 1.5 0 0 0 1.667-.316.187.187 0 0 1 .193-.045l1.633.543a.19.19 0 0 1 .126.15 1.5 1.5 0 0 0 2.988-.205c0-.201-.04-.4-.12-.586a.188.188 0 0 1 .03-.195l2.284-2.664a.187.187 0 0 1 .216-.05A1.5 1.5 0 1 0 18.75 3ZM3.75 21.375h16.5a.75.75 0 1 0 0-1.5H3.75a.75.75 0 1 0 0 1.5Z",
  fill: "#fff"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };